const clientId = "57d78c7b-0c9f-416e-8c5a-0ac66f04cf48"; //GUID Client Application ID
//const clientId = "5ba09613-bfc9-4988-93b4-90999978e29d"; // this is the application id for the vitalsmd-api
const tenantId = "6aa88db0-b38c-43a9-83a7-18c2294002e5"; //GUID Azure Tenant ID
const resourceId = "api://5ba09613-bfc9-4988-93b4-90999978e29d"; //GUID API Application ID
const authority = `https://login.microsoftonline.com/${tenantId}`;
const redirect_uri = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ""}`;

export const msalConfig = {
    auth: {
        clientId: clientId,
        authority: authority,
        redirectUri: redirect_uri,
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    //scopes: [`${msalConfig.auth.clientId}/.default`] // this scope might be necessary for the api
    //scopes: ["User.Read"]
    scopes: ["api://5ba09613-bfc9-4988-93b4-90999978e29d/VitalsMD_Data_Read"]
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com"
};